// Modules
import { createSelector } from 'reselect'

// Store
import selfSelector from './self'

export const tokenSelector = createSelector(selfSelector, (self) => self.token)

export const isAuthenticatedSelector = createSelector(selfSelector, (self) => self.isAuthenticated)

export const isAccessDeniedSelector = createSelector(selfSelector, (self) => self.isAccessDenied)

export const loadingSelector = createSelector(selfSelector, (self) => self.loading)
export const errorSelector = createSelector(selfSelector, (self) => self.error)

export const forgotPasswordSelector = createSelector(selfSelector, (self) => self.forgotPassword)
export const resetPasswordSelector = createSelector(selfSelector, (self) => self.resetPassword)
export const registrationSelector = createSelector(selfSelector, (self) => self.registration)
export const authTabsSelector = createSelector(selfSelector, (self) => self.authTabs)
export const contactLandingFormSelector = createSelector(
  selfSelector,
  (self) => self.contactLandingForm,
)
